import React from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";

const themeDefault = createMuiTheme({
  palette: {
    primary: {
      main: "#F9004DFF",
      contrastText: "#fff",
    },
    secondary: {
      main: "#284057",
    },
    background: {
      paper: "#fff",
      default: "#ebebeb",
    },
  },
  typography: {
    // Use the system font over Roboto.
    fontFamily: 'Avenir Next, Roboto,"Helvetica Neue",Arial,sans-serif',
    htmlFontSize: 16,
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        backgroundColor: "#fff"
      },
    }
  }

});

const themeDark = createMuiTheme({
  palette: {
    background: {
      default: "#e4f0e2"
    }
  }
});

const Theme = (props) => {
  return (
    <MuiThemeProvider theme={themeDefault ? themeDefault : themeDark}>
      <CssBaseline />
      {props.children}
    </MuiThemeProvider>
  );
};

export default Theme;
